"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGOptionsScene = void 0;
const CTGMenuScene_1 = require("../CTGMenuScene");
const FBDMenuToggleOption_1 = require("../FBDMenuToggleOption");
const CTGOptions_1 = require("../CTGOptions");
const CTG_1 = require("../CTG");
class CTGOptionsScene extends CTGMenuScene_1.CTGMenuScene {
    constructor() {
        super("CTGOptionsScene");
    }
    onCreate() {
        super.onCreate();
        this.setTitle("Options");
        this.addMenuOption(new FBDMenuToggleOption_1.FBDMenuToggleOption("Sound: ", "", (idx) => {
            CTGOptions_1.global_options.mute = !idx;
            CTG_1.game.sound.mute = CTGOptions_1.global_options.mute;
            CTGOptions_1.global_options.save();
        }, !CTGOptions_1.global_options.mute));
        let options = [];
        for (let i = 1; i <= 10; i++) {
            options.push("" + i);
        }
        this.addPreferenceOptionSingleDescription("Scale: ", "", options, (idx) => {
            CTG_1.set_scale(idx + 1);
            CTGOptions_1.global_options.save();
        }, CTGOptions_1.global_options.scale - 1);
    }
}
exports.CTGOptionsScene = CTGOptionsScene;
